<div style="page-break-inside: avoid;" *ngIf="isViewReady()" class="mt-4"
    [ngClass]="{'container': !isSinglePageReturn, 'return-view-background-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
    <div class="row mb-4">
        <div class="col-12 text-center">
            <strong>PARTICULARS OF FINANCIAL ASSETS AND BANK/FI ACCOUNT/CARDS</strong><br />
            <i>[Attachment for serial no 8(f) of IT-10B (2023)]</i>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6"><strong>Taxpayer Name:</strong> {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-6 text-right">
            <strong>Assessment Year:</strong> {{returnData?.submissionInfo?.assessmentYear}}
        </div>
    </div>
    <div class="row mt-3 mb-5">
        <div class="col-sm-12">
            <strong>TIN</strong>&ensp;&ensp;
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')"
                    class="input-default" disabled />
            </span>
        </div>
    </div>

    <div *ngIf="shareDebenture?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Share, debenture, bond, securities, unit certificates
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">BO Account/Instrument/ISIN no.</td>
                        <td class="text-center">Type of Acquisition</td>
                        <td class="text-center">Name of Brokerage House/Bank/FI</td>
                        <td class="text-center">Cost Value</td>
                    </tr>
                    <tr *ngFor="let item of shareDebenture; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item?.relatedIN}}</td>
                        <td class="text-start pr-3">{{item?.type}}</td>
                        <td class="text-start pr-3">{{item?.name}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="sanchayapatra?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Sanchayapatra
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Type of Sanchayapatra</td>
                        <td class="text-center">Registration No.</td>
                        <td class="text-center">Issue Date</td>
                        <td class="text-center">Value</td>
                    </tr>
                    <tr *ngFor="let item of sanchayapatra; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item?.type}}</td>
                        <td class="text-start pr-3">{{item?.relatedIN}}</td>
                        <td class="text-start pr-3">{{item?.dateOfIssue}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="fdrInfo?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Fixed/Term Deposits
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Particulars</td>
                        <td class="text-center">Name of Bank/FI</td>
                        <td class="text-center">Account No.</td>
                        <td class="text-center">Year end balance</td>
                    </tr>
                    <tr *ngFor="let item of fdrInfo; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{'FDR/ Term Deposit'}}</td>
                        <td class="text-start pr-3">{{item?.name}}</td>
                        <td class="text-start pr-3">{{item?.relatedIN}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="dpsInfo?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            DPS
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Particulars</td>
                        <td class="text-center">Name of Bank/FI</td>
                        <td class="text-center">Account No.</td>
                        <td class="text-center">Year end balance</td>
                    </tr>
                    <tr *ngFor="let item of dpsInfo; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{'DPS'}}</td>
                        <td class="text-start pr-3">{{item?.name}}</td>
                        <td class="text-start pr-3">{{item?.relatedIN}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="loanInfo?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Loans Given to Others
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Particulars</td>
                        <td class="text-center">Name of the Borrower</td>
                        <td class="text-center">TIN of the Borrower</td>
                        <td class="text-center">Amount</td>
                    </tr>
                    <tr *ngFor="let item of loanInfo; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item.description}}</td>
                        <td class="text-start pr-3">{{item?.name}}</td>
                        <td class="text-start pr-3">{{item?.relatedIN}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="providentFund?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Provident Fund & other Fund
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Name of Employer</td>
                        <td class="text-center">Particulars</td>
                        <td class="text-center">Account No.</td>
                        <td class="text-center">Year end balance</td>
                    </tr>
                    <tr *ngFor="let item of providentFund; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item.name}}</td>
                        <td class="text-start pr-3">{{item?.description}}</td>
                        <td class="text-start pr-3">{{item?.relatedIN}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="otherInfo?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Other Financial Assets
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Particulars</td>
                        <td class="text-center">Type of Acquisition</td>
                        <td class="text-center">Details</td>
                        <td class="text-center">Amount</td>
                    </tr>
                    <tr *ngFor="let item of otherInfo; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item.description}}</td>
                        <td class="text-start pr-3">{{item?.type}}</td>
                        <td class="text-start pr-3">{{item?.otherInfo}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div *ngIf="bankInfo?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Bank account/Card/Electronic Cash
        </div>
        <div class="col-12">
            <table class="table table-bordered">
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Type</td>
                        <td class="text-center">Name of Bank/FI</td>
                        <td class="text-center">Account No.</td>
                        <td class="text-center">Year end balance</td>
                    </tr>
                    <tr *ngFor="let item of bankInfo; let i = index">
                        <td class="text-center">{{i+1}}</td>
                        <td class="text-start">{{item?.type}}</td>
                        <td class="text-start pr-3">{{item?.name}}</td>
                        <td class="text-start pr-3">{{item?.relatedIN}}</td>
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>